import { PUSH_ROUTE } from '../../actions/ui/types';

/**
 * custom middleware to route on action dispatch.
 * @returns {function({dispatch: *}): function(*): function(*): *}
 */
function createRouterMiddleware() {
  return () => (next) => (action) => {
    const { type } = action;
    if (type === PUSH_ROUTE) {
      const { history, route, delay = 0 } = action.payload;
      setTimeout(() => history.push(route), delay);
    }

    return next(action);
  };
}

const routerMiddleware = createRouterMiddleware();

export default routerMiddleware;
